<template>
    <div class="FM_agentWithdrawalLists">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="withdrawlForm" class="demo-form-inline">
                <el-form-item>
                    <el-select
                        size
                        v-model="withdrawlForm.type"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="未分配分润" value="3"></el-option>
                        <el-option label="分润账户税点/手续费" value="0"></el-option>
                        <el-option label="活动账户税点/手续费" value="1"></el-option>
                        <el-option label="市场账户税点/手续费" value="2"></el-option>
                        <el-option label="月结分润" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="withdrawlForm.intype"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="转入市场账户" value="1"></el-option>
                        <el-option label="提现进入银行卡" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="withdrawlForm.status"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="已提交" value="1"></el-option>
                        <el-option label="已确认" value="2"></el-option>
                        <el-option label="已到账" value="3"></el-option>
                        <el-option label="已拒绝" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(withdrawlForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 平台表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="shWithdrawalTable"
                size="mini"
                border
                style="width: 100%"
            >
                <!-- id -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="50"
                ></el-table-column>
                <!-- 机构 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_name"
                    label="机构"
                    min-width="200"
                ></el-table-column>
                <!-- 账户类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="intype"
                    label="账户类型"
                    min-width="120"
                ></el-table-column>
                <!-- 渠道 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="type_name"
                    label="渠道"
                    min-width="150"
                ></el-table-column>
                <!-- 详情 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="detail"
                    label="详情"
                    min-width="250"
                ></el-table-column>
                <!-- 金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="money"
                    label="金额"
                    min-width="100"
                ></el-table-column>
                <!-- 金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="true_amount"
                    label="实际到账"
                    min-width="100"
                ></el-table-column>
                <!-- 到账银行 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_name"
                    label="到账银行"
                    min-width="150"
                ></el-table-column>
                <!-- 户名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_acc_name"
                    label="户名"
                    min-width="80"
                ></el-table-column>
                <!-- 账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_acc_no"
                    label="账号"
                    min-width="100"
                ></el-table-column>
                <!-- 当前状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status_name"
                    label="当前状态"
                    min-width="100"
                ></el-table-column>
                <!-- 提现时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="提现时间"
                    min-width="150"
                ></el-table-column>
                <!-- 审核时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="pass_time"
                    label="到账时间"
                    min-width="150"
                ></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "FM_agentWithdrawalLists",
    data() {
        return {
            shWithdrawalTable:[],
            loading:true,
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            withdrawlForm: {//平台搜索框
                type: '',
                intype: '',
                status: '',
                page: 1,
                limit: 10
            },
        }
    },
    mounted() {
        this.getData(this.withdrawlForm);
    },
    components: {
        paginations
    },
    methods: {
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.withdrawlForm.page = this.page.currentPage;
            this.withdrawlForm.limit = this.page.pageSize;
            this.getData();
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.withdrawlForm.page = this.page.currentPage;
            this.withdrawlForm.limit = limit;
            this.getData();
        },
        onSearch(){
            this.getData();
        },
        getData() {
            this.$api.post("organization/agentWithdrawLog", this.withdrawlForm, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.shWithdrawalTable = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
    }
};
</script>

<style lang="scss" scope>
.FM_agentWithdrawalLists {
    .realTitle {
        :nth-child(1) {
            font-size: 12px;
            font-weight: 700;
            color: #1e1e1e;
        }
        .imgParent {
            margin: 10px 0;
            // width: 500px;
            overflow: hidden;
            img {
                width: 100%;
                height: 250px;
                border-radius: 10px;
            }
        }
    }
    .el-dialog__header {
        padding: 20px 20px 0px;
    }
    .el-dialog__body {
        padding: 0px 20px 30px 20px;
    }
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>
